import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotification = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.1001 10.5V7.39999C13.099 6.35998 12.7799 5.34518 12.1857 4.49164C11.5914 3.63811 10.7505 2.98664 9.7755 2.62459C9.70683 2.20291 9.49041 1.81939 9.16493 1.54263C8.83945 1.26586 8.42614 1.11389 7.9989 1.11389C7.57166 1.11389 7.15834 1.26586 6.83286 1.54263C6.50739 1.81939 6.29096 2.20291 6.2223 2.62459C5.24745 2.98652 4.40666 3.63803 3.8128 4.49164C3.21895 5.34526 2.90046 6.36013 2.9001 7.39999V10.5C2.0001 11.6 1.6001 12 1.6001 13.1H14.4001C14.4001 12 14.0001 11.6 13.1001 10.5Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.79995 13.6C9.79995 14.0774 9.61031 14.5352 9.27274 14.8728C8.93518 15.2103 8.47734 15.4 7.99995 15.4C7.52256 15.4 7.06472 15.2103 6.72716 14.8728C6.38959 14.5352 6.19995 14.0774 6.19995 13.6",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgNotification);
export default ForwardRef;
